<template>
  <el-dialog
    v-model="isVisible"
    class="order-test related-tests-dialog"
    title=""
    :show-close="false"
    modal-class="consultation-fee-dialog"
    append-to-body
    @close="close"
  >
    <template #header>
      <div class="flex justify-between items-center px-6 py-4 bg-[#004879] text-white rounded-t-[10px]">
        <span class="font-semibold text-[20px] leading-normal">Consultation Fee - This Order Only</span>
        <button class="bg-transparent border-none p-0 cursor-pointer w-7 h-7" @click="close">
          <img src="@/assets/MyPatient/close.svg" alt="Close" class="w-full h-full" />
        </button>
      </div>
    </template>
    <div class="dialog-container my-6 mx-auto">
      <Alert :height="35" type="info">
        <div class="flex items-center restriction-box pt-2 pr-3">
          <img src="@/assets/orderTest/blue_info.svg" class="pl-3 px-2" alt="error outline">
          <div>
            <span class="restriction-text">{{ $t("OrderPage[\"This will only affect this order, not the default price\"]") }}</span>
          </div>
        </div>
      </Alert>
      <div class="mt-4 flex justify-between">
        <div>
          <div class="mb-1">{{ $t("OrderPage[\"Fee Name\"]") }}<span class="star">*</span></div>
          <div>
            <el-input
              class="value-input w-2/5"
              :class="!nameInput ? 'error-input' : ''"
              v-model="nameInput"
              maxlength="100"
              :placeholder="$t('OrderPage[\'Enter Customized Fee Name\']')"
            >
            </el-input>
          </div>
          <div class="error-container">
            <p class="error" v-if="!nameInput.trim()">{{ $t("OrderPage[\"Fee name must not be empty.\"]") }}</p>
            <p class="error" v-if="invalidNameInput">{{ $t("OrderPage[\"The name you customized should be distinct from Vibrant charging services.\"]") }}</p>
            <p class="error" v-if="digitNameInput">{{ $t("OrderPage[\"Your customized name must include letters.\"]") }}</p>
            <p class="error" v-if="specCharNameInput">
              {{ $t("OrderPage[\"Your customized name could not include special characters &#40; &#33; &#64; &#35;, etc &#41;.\"]") }}
            </p>
          </div>
        </div>
        <div>
          <div class="mb-1">{{ $t("OrderPage[\"Amount\"]") }}<span class="star">*</span></div>
          <div>
            <el-input
              class="value-input w-2/5"
              :class="!valueInput.trim() ? 'error-input' : ''"
              v-model="valueInput"
              :placeholder="$t('OrderPage[\'Enter Fee Amount\']')"
              @input="onValueInput"
            >
              <template v-slot:prefix>
                <div class="pl-4 text-black">{{ currencySign }}</div>
              </template>
            </el-input>
            <div class="error-container">
              <p class="error" v-if="!valueInput.trim()">{{ $t("OrderPage[\"Amount must not be empty.\"]") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="description mt-2">
        {{ $t("OrderPage[\"A Consultation Fee will be added to the order as part of provider revenue, with a shared transaction fee deducted.\"]") }}
      </div>
      <div class="flex justify-end mt-12 pb-6">
        <el-button class="cancel-btn btn" @click="close">
          {{ $t("OrderPage[\"Cancel\"]") }}
        </el-button>
        <el-button 
          class="confirm-btn btn"
          :disabled="!valueInput.trim() || !nameInput.trim()" 
          @click="confirm"
        >
          {{ $t("OrderPage[\"Save\"]") }}
        </el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import Alert from '@/views/va-orderTest/components/Alert.vue';
import { mapState } from "vuex";

export default {
  components: {
    Alert,
  },

  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    charges: {
      type: Number,
      default: 0.0
    },
  },

  data() {
    return {
      isVisible: false,
      valueInput: "",
      nameInput: "",
    }
  },

  emits: ["close"],

  computed: {
    ...mapState(["currency"]),
    ...mapState("orderTest/order", ["consultationFee"]),
    ...mapState("orderTest", ["defaultSettings"]),
    ...mapState(["currency"]),
    currencySign() {
      return this.currency ? this.currency.symbol : "$";
    },

    formattedInput() {
      if (!this.valueInput) {
        return 0;
      }
      let val = parseFloat(this.valueInput);
      return Math.round(val * 100)/100;
    },

    invalidNameInput() {
      const trimmedInput = this.nameInput.trim().toLocaleUpperCase();
      const invalidTerms = /^(lab\s+processing\s+fee|shipping\s+fee|export\s+fee|import\s+fee|concierge\s+blood\s+draw\s+fee|tax|test\s+total|discount|applied\s+payment|international\s+shipping\s+fee)$/i;

      return invalidTerms.test(trimmedInput);
    },

    digitNameInput() {
      const trimmedInput = this.nameInput.trim();
      return /^\d+$/.test(trimmedInput);
    },

    specCharNameInput() {
      const trimmedInput = this.nameInput.trim();
      // Regular expression to check for special characters (non-alphanumeric characters)
      return /[^a-zA-Z0-9\s]/.test(trimmedInput);
    }
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    },

  },

  mounted() {
    if (this.consultationFee.amount > 0) {
      this.valueInput = this.consultationFee.amount.toFixed(2);
    }
    this.nameInput = this.consultationFee.name ? this.consultationFee.name : "Consultation Fee";
  },

  methods: {
    close() {
      if (this.consultationFee.amount > 0) {
        this.valueInput = this.consultationFee.amount.toFixed(2);
      } else {
        this.valueInput = "";
        
      }
      this.nameInput = this.consultationFee.name;
      this.$emit("close");
    },   
    
    confirm() {
      let consultationFee = {
        amount: this.formattedInput,
        isUse: this.formattedInput > 0,
        name: this.nameInput.trim(),
      }
      this.$store.dispatch("orderTest/order/setConsultationFee", consultationFee);
      this.close();
    },

    onValueInput(event) {
      const cleanedInput = event.replace(/[^\d.]/g, '');
      this.valueInput = cleanedInput;
    },
  }
}
</script>

<style>
.consultation-fee-dialog .el-dialog {
  border-radius: 10px;
  --el-dialog-padding-primary: 0px !important;
}
.consultation-fee-dialog .el-dialog__header {
  padding: 0;
  border-bottom: none;
}
.consultation-fee-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.dialog-container {
  width: 568px;
}

.value-input {
  box-sizing: border-box;
  width: 263px;
  height: 42px;

  border-radius: 4px;
  border: 1px solid #B5B5B5;
  background: #FFF;
}

.value-input.error {
  border: 1px solid #F00;
}

.description {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  line-height: 17.58px;
  color: #979797;
}

.btn {
  display: flex;
  width: 100px;
  height: 42px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  text-align: center;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 173.333% */
  letter-spacing: 0.43px;
}

.cancel-btn, .cancel-btn:hover {
  border-radius: 5px;
  border: 1px solid #F3F3F3;
  background: #F3F3F3;
  color: #4A4A4A; 
}

.confirm-btn, .confirm-btn:hover {
  border-radius: 5px;
  border: 1px solid #004879 !important;
  background: #004879 !important;
  color: #FFF !important;
}

.star {
  color: var(--color-Functional-Red-status-000, #FF1010);
}

.error-container {
  height: 20px;
  width: 263px;
}

.error {
  color: #DA1E28;
  font-size: 12px;
  line-height: 12px;

  word-break: break-word;
  white-space: normal;
}

.error-input {
  border: 1px solid #F00;
}
</style>